
import { windownLoad } from './utils/Events';

import './Validation';
import { startAOS } from './effects/AnimationOnScroll';

import { startScrollTrigger } from './effects/ScrollTrigger'
import Ripple from './effects/ButtonMaterialRipple'
import $ from 'cash-dom';
import { setupAutoGrow } from './forms/TextareaAutoSize';

$('html').removeClass('no-js');

Ripple.init();



setupAutoGrow($('textarea'));
windownLoad(() =>{
    startScrollTrigger();
    startAOS();

});

